import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export interface EmptyStateProps {
	/** Иконка 32px или картинка 48px — глиф над текстом, не вместо него. */
	icon?: ReactNode;
	title: ReactNode;
	description?: ReactNode;
	action?: ReactNode;
	className?: string;
}

/**
 * Пустое состояние, оно же ошибка и офлайн: одна форма, разный текст.
 * Формулировка говорит, чего не хватает, и что с этим сделать, — «Ничего нет»
 * без продолжения оставляет человека в тупике.
 */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
	return (
		<div
			className={cn(
				"flex w-full flex-col items-center justify-center gap-1 px-5 py-10 text-center",
				className,
			)}
		>
			{icon ? <span className="mb-2 text-fg-muted">{icon}</span> : null}
			<span className="t-body inline-block rounded-sm bg-warm px-2 py-1">{title}</span>
			{description != null ? (
				<span className="t-body inline-block max-w-[42ch] rounded-sm bg-warm px-2 py-1 text-fg-muted">
					{description}
				</span>
			) : null}
			{action != null ? <span className="mt-3">{action}</span> : null}
		</div>
	);
}
